import React, {useState} from "react";
import opportunityValidationService from "../../../../../services/oneButtonServices/opportunityValidationService";
import {Switch} from "antd";

interface ValidationStatusSwitchProps {
    oppId: number;
    source: string;
    field: string;
    status: boolean;
}

export const ValidationStatusSwitch: React.FC<ValidationStatusSwitchProps> = ({oppId, source, field, status}) => {

    const [loading, setLoading] = useState(false);
    const [checked, setChecked] = useState(status);

    const saveValidationStatus = (field: string, status: boolean) => {
        setLoading(true);

        const request = {
            opportunityId: Number(oppId),
            source: source,
            field: field,
            status: status,
        };

        opportunityValidationService.saveValidationStatus(request)
            .then(result => {
                if (!result) {
                    return;
                }

                setChecked(status);
            })
            .finally(() => setLoading(false));
    };

    return (
        <Switch
            loading={loading}
            checked={checked}
            onChange={(value) => saveValidationStatus(field, value)}/>
    );
}